import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';

// categories: lista de strings já cadastradas
// onAddCategory(nome): persiste a categoria nova (ex.: PUT /settings/) — deve lançar em caso de erro
export default function CategoriaSelect({ categories = [], value, onChange, onAddCategory }) {
  const [showAdd, setShowAdd] = useState(false);
  const [novaCategoria, setNovaCategoria] = useState('');
  const [saving, setSaving] = useState(false);

  const salvar = async () => {
    const nome = novaCategoria.trim();
    if (!nome) return;
    setSaving(true);
    try {
      await onAddCategory(nome);
      onChange(nome);
      setNovaCategoria('');
      setShowAdd(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <div className="flex gap-2">
        <select className="field-select flex-1" value={value} onChange={e => onChange(e.target.value)}>
          <option value="">Selecionar...</option>
          {categories.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <button
          type="button"
          onClick={() => setShowAdd(true)}
          className="px-3 border border-zinc-700 rounded-xl text-zinc-400 hover:text-white hover:border-orange-500 transition-colors"
        >
          <Plus size={16} />
        </button>
      </div>

      {showAdd && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4">
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl w-full max-w-sm">
            <div className="flex items-center justify-between p-4 border-b border-zinc-800">
              <h3 className="font-heading font-semibold text-white text-sm">Nova categoria de despesa</h3>
              <button onClick={() => setShowAdd(false)} className="text-zinc-500 hover:text-white"><X size={18} /></button>
            </div>
            <div className="p-4">
              <input
                className="field-input"
                placeholder="Nome da categoria"
                value={novaCategoria}
                onChange={e => setNovaCategoria(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && salvar()}
                autoFocus
              />
            </div>
            <div className="p-4 border-t border-zinc-800 flex justify-end gap-2">
              <button onClick={() => setShowAdd(false)} className="px-3 py-1.5 text-sm text-zinc-400 hover:text-white">Cancelar</button>
              <button onClick={salvar} disabled={saving} className="bg-orange-500 hover:bg-orange-400 disabled:opacity-50 text-white text-sm font-semibold px-4 py-1.5 rounded-xl transition-colors">
                {saving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
